import React from "react";

// Local Libraries
import phrasebookLoad from "../../../i18n";
import { gisRoutes } from "../../../routes/routes";


import * as token from "../../../helpers/token";
import { accountTypesConstants } from "../../../constants";

import { trueOrFalse, required, ifZero, noMaximum, capitalizeFirstLetter, applicable } from "../../../helpers/util";


//Redux
import {
  invnumberActions
} from "actions";

//Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { ProgressTab } from "../../../components/SkyFramework/ProgressTab/ProgressTab";
import { CancelButton } from "../../../components/SkyFramework/Buttons";
import { Tooltip } from "../../../components/SkyFramework/Helpers/Tooltip";



import { connect } from "react-redux";

// Constants
const phrasebook = phrasebookLoad();

class Ordering extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.match.params.id,
      vendor_insight_code: undefined,
      vendor_plan: undefined,
      customer_insight_code: undefined,
      vendor_option: undefined,
      order_id: undefined,
      routing_vendor: undefined,
      translated_routing: undefined,
      ocn_for_customer: undefined,
      jurisdiction: undefined,
      translation_termination_number: undefined,
      service_number: undefined,
      irouting_billing: undefined,
      currency: undefined,
      inbound_charges: undefined,
      billing_incremental: undefined,
      nrc: undefined,
      mrc: undefined,
      commencement_date: undefined,
      sr_reference: undefined,
      pccwg_remarks: undefined,
      expired: undefined,
      expiration_date: undefined,
      daisy_loopback_trunk: undefined,
      allinone_loopback_trunk: undefined,
      updatedAt: undefined,
      service_type: undefined,
      access_type: undefined,
      number_type: undefined,
      city: undefined,
      bothways_enabled: undefined,
      over_limited_channel: undefined,
      billing_start_date: undefined,
      outbound_idd_callout_country: undefined,
      outbound_charges_fixed: undefined,
      outbound_charges_mobile: undefined,
      outbound_charges_special: undefined,
      invnumber: undefined
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    if (this.props.match.params.id)
      this.props.dispatch(invnumberActions.get(this.props.match.params.id));
  }

  componentDidUpdate(prevProps) {

    if (this.props.invnumber && prevProps && prevProps.invnumber !== this.props.invnumber) {
      this.setState({
        vendor_insight_code: this.props.invnumber.vendor_insight_code,
        vendor_plan: this.props.invnumber.vendor_plan,
        customer_insight_code: this.props.invnumber.customer_insight_code,
        vendor_option: this.props.invnumber.vendor_option,
        order_id: this.props.invnumber.order_id,
        routing_vendor: this.props.invnumber.routing_vendor,
        translated_routing: this.props.invnumber.translated_routing,
        ocn_for_customer: this.props.invnumber.ocn_for_customer,
        jurisdiction: this.props.invnumber.jurisdiction,
        translation_termination_number: this.props.invnumber.translation_termination_number,
        service_number: this.props.invnumber.service_number,
        irouting_billing: this.props.invnumber.irouting_billing,
        currency: this.props.invnumber.currency,
        inbound_charges: this.props.invnumber.inbound_charges,
        billing_incremental: this.props.invnumber.billing_incremental,
        nrc: this.props.invnumber.nrc,
        mrc: this.props.invnumber.mrc,
        commencement_date: this.props.invnumber.commencement_date,
        sr_reference: this.props.invnumber.sr_reference,
        pccwg_remarks: this.props.invnumber.pccwg_remarks,
        expired: this.props.invnumber.expired,
        expiration_date: this.props.invnumber.expiration_date,
        daisy_loopback_trunk: this.props.invnumber.daisy_loopback_trunk,
        allinone_loopback_trunk: this.props.invnumber.allinone_loopback_trunk,
        updatedAt: this.props.invnumber.updatedAt,
        service_type: this.props.invnumber.service_type,
        access_type: this.props.invnumber.access_type,
        number_type: this.props.invnumber.number_type,
        city: this.props.invnumber.city,
        bothways_enabled: this.props.invnumber.bothways_enabled,
        over_limited_channel: this.props.invnumber.over_limited_channel,
        billing_start_date: this.props.invnumber.billing_start_date,
        outbound_idd_callout_country: this.props.invnumber.outbound_idd_callout_country,
        outbound_charges_fixed: this.props.invnumber.outbound_charges_fixed,
        outbound_charges_mobile: this.props.invnumber.outbound_charges_mobile,
        outbound_charges_special: this.props.invnumber.outbound_charges_special,
        invnumber: this.props.invnumber
      });
    }
  }

  // trueOrFalse, required, ifZero, noMaximum, capitalizeFirstLetter, applicable
  InvNumberInfo() {
    if (this.state.invnumber) {
      var info = [
        {
          label: phrasebook.numbers.vendor_insight_code,
          value: this.state.vendor_insight_code
        },
        {
          label: phrasebook.numbers.vendor_plan,
          value: applicable(this.state.vendor_plan)
        },
        {
          label: phrasebook.numbers.customer_insight_code,
          value: this.state.customer_insight_code
        },
        {
          label: phrasebook.numbers.vendor_option,
          value: this.state.vendor_option
        },
        {
          label: phrasebook.orders.order_id,
          value: applicable(this.state.order_id)
        },
        {
          label: phrasebook.numbers.routing_vendor,
          value: applicable(this.state.routing_vendor)
        },
        {
          label: phrasebook.numbers.translated_routing,
          value: this.state.translated_routing
        },
        {
          label: phrasebook.numbers.ocn_for_customer,
          value: this.state.ocn_for_customer
        },
        {
          label: phrasebook.common.destination,
          value: this.state.jurisdiction
        },
        {
          label: phrasebook.numbers.translation_termination_number,
          value: this.state.translation_termination_number
        },
        {
          label: phrasebook.numbers.originating_dialed_number,
          value: this.state.service_number
        },
        {
          label: phrasebook.numbers.irouting_billing,
          value: this.state.irouting_billing
        },
        {
          label: phrasebook.references.currency,
          value: this.state.currency
        },
        {
          label: phrasebook.pricing.inbound_charges,
          value: ifZero(this.state.inbound_charges)
        },
        {
          label: phrasebook.pricing.billing_incremental,
          value: this.state.billing_incremental
        },
        {
          label: phrasebook.pricing.nrc,
          value: ifZero(this.state.nrc)
        },
        {
          label: phrasebook.pricing.mrc,
          value: ifZero(this.state.mrc)
        },
        {
          label: phrasebook.common.commencement_date,
          value: this.state.commencement_date
        },
        {
          label: phrasebook.numbers.sr_reference,
          value: this.state.sr_reference
        },
        {
          label: phrasebook.common.remarks,
          value: this.state.pccwg_remarks
        },
        {
          label: phrasebook.common.expired,
          value: trueOrFalse(this.state.expired)
        },
        {
          label: phrasebook.common.expiration_date,
          value: applicable(this.state.expiration_date)
        },
        {
          label: phrasebook.numbers.daisy_loopback_trunk,
          value: this.state.daisy_loopback_trunk
        },
        {
          label: phrasebook.numbers.allinone_loopback_trunk,
          value: this.state.allinone_loopback_trunk
        },
        {
          label: phrasebook.common.last_updated,
          value: this.state.updatedAt
        },
        {
          label: phrasebook.numbers.service_type,
          value: this.state.service_type
        },
        {
          label: phrasebook.numbers.access_type,
          value: applicable(this.state.access_type)
        },
        {
          label: phrasebook.numbers.number_type,
          value: this.state.number_type
        },
        {
          label: phrasebook.references.city,
          value: this.state.city
        },
        {
          label: phrasebook.numbers.bothways_enabled,
          value: trueOrFalse(this.state.bothways_enabled)
        },
        {
          label: phrasebook.numbers.over_limited_channel,
          value: trueOrFalse(this.state.over_limited_channel)
        },
        {
          label: phrasebook.pricing.billing_start_date,
          value: this.state.billing_start_date
        },
        {
          label: phrasebook.numbers.outbound_idd_callout_country,
          value: this.state.outbound_idd_callout_country
        },
        {
          label: phrasebook.pricing.outbound_charges_fixed,
          value: ifZero(this.state.outbound_charges_fixed)
        },
        {
          label: phrasebook.pricing.outbound_charges_mobile,
          value: ifZero(this.state.outbound_charges_mobile)
        },
        { label: phrasebook.pricing.outbound_charges_special, value: applicable(this.state.outbound_charges_special) },
      ]

      return <div class="section-block">
        {info.map(row => {
          if (Array.isArray(row)) {
            return <div class="section-block mt-3">
              {row.map(rowblock => {
                if (rowblock.value === 'title') return <h3 class="mb-2"> <strong>{rowblock.label}</strong></h3>
                else if (rowblock.value === 'subtitle') return <h4> {rowblock.label}</h4>
                else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
                  <span>{rowblock.label} <Tooltip tooltip={rowblock.tooltip}></Tooltip> </span>
                  <span><strong>{rowblock.value}</strong> </span>
                </div>
              })}
            </div>
          }
          if (row.value === 'title') return <h3 class="mb-2"> <strong>{row.label}</strong></h3>
          else if (row.value === 'subtitle') return <h4> {row.label}</h4>
          else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
            <span> {row.label} <Tooltip tooltip={row.tooltip}></Tooltip></span>
            <span><strong>{row.value}</strong> </span>
          </div>
        })}
      </div>
    }
  }


  render() {
    if (this.state.invnumber) {

      return (
        <>
          <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.invnumber.list, label: phrasebook.headerlinks.invnumbers }]} current={`${phrasebook.headerlinks.invnumber}`} />
          <form class="box p-1 p-sm-2 p-lg-3">
            <div class="container-xs p-0">
              <h2 class="box-title pb-1 mb-1">{phrasebook.headerlinks.invnumber}</h2>

              <div class="section-block mt-2">
                <div class="d-flex mb-2">
                  <h3 class="mb-0 mr-h"><strong>{phrasebook.numbers.invnumber_details}</strong></h3>
                </div>
              </div>
              <hr class="dotted my-3" />
              {this.InvNumberInfo()}

            </div>
            <div class="box-actions-footer mt-4"><CancelButton
              link={gisRoutes.management.invnumber.list} title={phrasebook.numbers.back_to_invnumbers} /></div>
          </form>


          {/* {summaryButtons(this.state, loggedAccount, handleSubmit, prevStep, saveChanges)} */}
        </>
      );
    } else return null

  }
}

function mapStateToProps(state) {
  const {
    loggedpermissions,
    authentication,
    invnumber,
  } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    invnumber: invnumber.invnumber,
  };
}

const invnumbering = connect(mapStateToProps)(Ordering);
export default invnumbering;
